import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const NumberInput = ({ valueSpec, onChange }) => {
  const [sValue, setSValue] = useState(null);
  const [tValue, setTValue] = useState("");

  useEffect(() => {
    setSValue(Number(valueSpec.value));
    setTValue(Number(valueSpec.value));
    return () => {};
  }, [valueSpec]);

  const handleSliderChange = (e, v) => {
    setSValue(v);
    setTValue(v);
    onChange(v.toString());
  };

  const handleNumberInputChange = event => {
    if (event.target.value === "") {
      setSValue(0);
      setTValue("");
    } else {
      const newValue = Number(event.target.value);
      setSValue(newValue);
      setTValue(newValue);
      onChange(newValue.toString());
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Grid container spacing={1} direction="column">
        {valueSpec.name && (
          <Grid item xs>
            <Typography variant="h6">{valueSpec.name}</Typography>
          </Grid>
        )}
        <Grid item xs>
          <Grid container spacing={1} columns={{ xs: 12 }}>
            {valueSpec.min !== null && valueSpec.max != null && (
              <Grid item xs={8}>
                <Box display="flex" alignItems="center">
                  <Slider
                    value={sValue}
                    aria-label="Slider"
                    valueLabelDisplay="auto"
                    onChange={handleSliderChange}
                    min={valueSpec.min}
                    max={valueSpec.max}
                  />
                </Box>
              </Grid>
            )}
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Number"
                type="number"
                value={tValue}
                onChange={handleNumberInputChange}
                inputProps={{ min: 0, max: 10, step: 1 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NumberInput;
